import { PuntosService, SolicitudPremioService } from "services/comunicacion-cultura";
import { puntosAtom, resumenAtom, solicitudesPremiosAtom } from "../store/store";
import { useAtom } from "jotai";

const usePuntosPage = () => {

    const [puntos, setPuntos] = useAtom(puntosAtom);
    const [resumen, setResumen] = useAtom(resumenAtom);
    const [solicitudesPremios, setSolicitudesPremios] = useAtom(solicitudesPremiosAtom);

    const fetchPuntos = async () => {
        const puntos = await PuntosService.listar();
        setPuntos(puntos);
    }

    const fetchResumen = async () => {
        const resumen = await PuntosService.getResumen();
        setResumen(resumen);
    }


    const fetchSolicitudesPremios = async () => {
        const puntos = await SolicitudPremioService.listar();
        setSolicitudesPremios(puntos);
    }

    return {
        puntos,
        resumen,
        solicitudesPremios,
        fetchResumen,
        fetchPuntos,
        fetchSolicitudesPremios
    };
};

export default usePuntosPage;